
import xinmeitiHome from '@/components/jm/xinmeiti/home.vue'
export default [{
	path: 'xinmeiti',
	name: 'xinmeiti',
	component: xinmeitiHome,
	// children: [
	// 	{ //app版本管理
	// 	path: 'androidMacLogHome',
	// 	name: 'androidMacLogHome',
	// 	component: androidMacLogHome,
	// 	children: [{
	// 		path: 'list',
	// 		name: 'jm/android/maclog/list',
	// 		component: androidMacLogList
	// 	}]
	// },
	// ]
}]



// WEBPACK FOOTER //
// ./src/router/jm/xinmeiti/xinmeiti.js